export default __webpack_public_path__ + "static/notebook-6bde412c8f20bdabfb547ea1bd651112.png";